import Layout from '@/views/Layout/index.vue'
const EducationPage = () => import('@/views/EducationPage/index.vue')

const Course = () => import('@/views/EducationPage/Course/index.vue')
const Package = () => import('@/views/EducationPage/Package/index.vue')
const Class = () => import('@/views/EducationPage/Class/index.vue')
const Lessons = () => import('@/views/EducationPage/Lessons/index.vue')
const Classroom = () => import('@/views/EducationPage/Classroom/index.vue')
const Arranging = () => import('@/views/EducationPage/Arranging/index.vue')
const MyArranging = () => import('@/views/EducationPage/MyArranging/index.vue')
const Record = () => import('@/views/EducationPage/Record/index.vue')
const MyRecord = () => import('@/views/EducationPage/MyRecord/index.vue')
const ClassDetail = () => import('@/views/EducationPage/ClassDetail/index.vue')
const BookingManage =()=> import('@/views/EducationPage/BookingManage/index.vue')
const RecordingLessons = ()=> import('@/views/EducationPage/RecordingLessons/index.vue')
const AddStudentScheduling = ()=> import('@/views/EducationPage/AddStudentScheduling/index.vue')
const JoinTheClass = ()=> import('@/views/EducationPage/JoinTheClass/index.vue')
const OneOnOneClass = ()=> import('@/views/EducationPage/Class/OneOnOneClass/index.vue')
const ClassPage = ()=> import('@/views/EducationPage/Class/ClassPage/index.vue')
const  FaceAttendance = ()=> import('@/views/EducationPage/FaceAttendance/index.vue')
const BatchPromotion = ()=>import('@/views/EducationPage/Class/BatchPromotion/index.vue')
export default {
    path: '/education',
    component: Layout,
    children: [
      {
        path: '',
        component: EducationPage,
        children: [
          {
            path: '',
            component: Course,
          },
          {
            path: 'package',
            component: Package,
          },{
            path:'batchPromotion',
            component:BatchPromotion
          },

          {
            path: 'class',
            component: Class,
          },
          {
            path: 'lessons',
            component: Lessons,
          },
          {
            path: 'classroom',
            component: Classroom,
          },{
            path: 'faceAttendance',
            component: FaceAttendance,
          },
          {
            path: 'arranging',
            component: Arranging,
          },
          {
            path: 'myarranging',
            component: MyArranging,
          },
          {
            path: 'record',
            component: Record,
          },
          {
            path: 'arranging',
            component: Arranging,
          },
          {
            path: 'myrecord',
            component: MyRecord,
          },
          {
            path: 'classdetail',
            component: ClassDetail,
          },{
            path:'bookingManage',
            component:BookingManage
          },
          {
            path:'recordingLessons',
            component:RecordingLessons
          },
          {
            path:'addStudentScheduling',
            component:AddStudentScheduling
          } ,{
            path:'joinTheClass',
            component:JoinTheClass
          }
        ]
      }
    ]
  }
